/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Ambienttemperaturecoolingsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Ambient cooling setpoint" |
*
* @param {Ahu_History_Key_Ambienttemperaturecoolingsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_ambienttemperaturecoolingsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Ambienttemperaturecoolingsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Ambienttemperaturecoolingsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid d'ambiance")
});
export { ahu_history_key_ambienttemperaturecoolingsetpoint3 as "ahu_history_key_ambientTemperatureCoolingSetpoint" }